// POST /v1/models/deploy-foundation - create a deployment directly
// from a foundation backbone (kind=foundation_backbone) without
// going through fine-tuning.
//
// Action payload shape:
//   { blueprint_uid: "pfm__..." | "extfm__...", horizon }

const action = "BLUEPRINT_DEPLOY_FOUNDATION";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
